import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ManualService } from 'src/app/services/panelM/manual.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  standalone: false,
  selector: 'app-auto',
  templateUrl: './auto.component.html',
  styleUrls: ['./auto.component.scss']
})
export class AutoComponent implements OnInit {
  charging = false;
  constructor(private readonly router: Router, private man: ManualService, private snackBar: MatSnackBar,) { }

  ngOnInit() {
  }

  updateBanks() {
    if (this.charging) {
      return;
    }
    this.charging = true;
    this.man.updateAuto().subscribe((data: any) => {
      this.charging = false;
      this.snackBar.open((data.Ok) ? 'Actualización correcta' : 'Error al actualizar', '', {
        duration: 3000,
      });
    }, (data) => {
      this.charging = false;
      this.snackBar.open((data.Ok) ? 'Actualización correcta' : 'Error al actualizar', '', {
        duration: 3000,
      });
    });
  }

}
